import { createSvgIcon } from '@mui/material/utils'

const ArrowUp = createSvgIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.29001 5.99708L7.99712 5.28998L8.70422 5.99708L12.7042 9.99708L11.9971 10.7042L7.99712 6.70419L3.99712 10.7042L3.29001 9.99708L7.29001 5.99708Z"
    />
  </>,
  'ArrowUp'
)

export default ArrowUp
